import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
/**
* @author
* @function ContactForm
**/

export const ContactForm = (props) => {
     const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        agree: false,
      });
    
      const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
          ...formData,
          [name]: type === "checkbox" ? checked : value,
        });
      };
            
      const encodeForGoogleForms = (str) => {
        return encodeURIComponent(str).replace(/%20/g, "+");
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
    
        if (!formData.agree) {
          alert("Please accept the Terms & Conditions");
          return;
        }
            
    
        const SENDURL = `https://docs.google.com/forms/d/e/1FAIpQLSc5dHKx7c_7h4Mm6wZNRLkOPL0l1T1ubRPuQOAoUSu-cXQmWA/formResponse?entry.1379870979=${encodeForGoogleForms(
          formData.name
        )}&entry.2094578453=${encodeForGoogleForms(
          formData.email
        )}&entry.1796976625=${encodeForGoogleForms(formData.mobile)}
        &entry.2036557743=yes`;
        // console.log("SENDURL",SENDURL);
        fetch(SENDURL, {
          method: "POST",
          mode: "no-cors",
        })
          .then(() => {
            alert("Thank you for showing your interset !...Our business team will reach you soon.")
            setFormData({ name: "", email: "", mobile: "",agree:false });
          })
          .catch((error) => {
            console.error("Error submitting form:", error);
          });
          
      };


  return(
    <div><Row>
    <Col md={12}>
      <h3 className="fw-semibold mb-3">Enquiry Form</h3>

      <Form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                type="tel"
                name="mobile"
                placeholder="Enter mobile number"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>


        <Form.Group className="mb-4">
          <Form.Check
            type="checkbox"
            label="I agree to the Terms & Conditions"
            name="agree"
            checked={formData.agree}
            onChange={handleChange}
          />
        </Form.Group>

        <button className="btn-jv" type="submit">
          Submit 
        </button>
      </Form>
    </Col>
  </Row></div>
   )
  }
